import { render, staticRenderFns } from "./free_vs_premium_comparison_table.vue.js?vue&type=template&id=39c37f71!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=template&id=39c37f71"
import script from "./free_vs_premium_comparison_table.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=script&lang=js"
export * from "./free_vs_premium_comparison_table.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=script&lang=js"
import style0 from "./free_vs_premium_comparison_table.vue.css?vue&type=style&index=0&id=39c37f71&lang=css!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=style&index=0&id=39c37f71&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c37f71')) {
      api.createRecord('39c37f71', component.options)
    } else {
      api.reload('39c37f71', component.options)
    }
    module.hot.accept("./free_vs_premium_comparison_table.vue.js?vue&type=template&id=39c37f71!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=template&id=39c37f71", function () {
      api.rerender('39c37f71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ee/app/assets/javascripts/vue_shared/subscription/components/free_vs_premium_comparison_table.vue"
export default component.exports